import { Button, Stack, Typography} from "@mui/material";
import Layout from "./components/Layout";
import Chat from "../Tools/Chat";
import { Link, Navigate, useParams } from "react-router-dom";
import useCart from "./utils/useCart";

export default function Auth(){

    const { id } = useParams()

    const { cart } = useCart()

    if( !cart.product ) return <Navigate to={`/courses/${id}/enroll`} />

    return (
        <Layout center>

            <Stack spacing={3} alignItems="start"  sx={{margin: 'auto'}}>

                <Typography variant="h1">
                    Bienvenue sur LearnyLib !
                </Typography>

                <Typography variant="h5">
                    Vous n'avez pas encore de compte LearnyLib ?
                </Typography>

                <Typography color="text.secondary">
                    Finalisez votre inscription et accédez à votre formation en un clic :
                </Typography>

                <Button 
                    variant="contained"
                    component={Link}
                    to={`/courses/${id}/signup?category=${cart.category || ''}&status=${cart.status || ''}`}
                    size="large"
                >
                    Créer mon compte
                </Button>

                <Typography variant="h5">
                    Vous êtes déjà membre LearnyLib ?
                </Typography>

                <Typography color="text.secondary">
                    Connectez-vous ci-dessous :
                </Typography>

                <Button 
                    variant="outlined"
                    component={Link}
                    to={`/courses/${id}/signin`}
                    size="large"
                >
                    Me connecter
                </Button>


            </Stack>


            <Chat />

        </Layout>
    );
}